import "reflect-metadata";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { DataGridActionTypes, DataGridAction } from "./DataGridActions";
import { store } from "../ConfigureStore";
import IDataGridService from "features/shared/components/dataGrid/IDataGridService";

const _dataGridService: IDataGridService = inversifyContainer.get(IocTypes.DataGridService);

const getComputedGridParams = (gridId: string):string => {
    const currentState = store.getState();
    return _dataGridService.computeQueryParams(currentState.dataGrid.gridSettings[gridId]);
}

function* handleSetGridUrlParams(action: DataGridAction) {    
    switch (action.type) {        
        case DataGridActionTypes.SET_GRID_FILTR_URLPARAMS_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data.key, value: getComputedGridParams(action.data.key) } })
            break;
        case DataGridActionTypes.RESET_GRID_FILTR_URLPARAMS_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data, value: getComputedGridParams(action.data) } })
            break;
        case DataGridActionTypes.SET_GRID_PAGINATION_URLPARAMS_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data.key, value: getComputedGridParams(action.data.key) } })
            break;
        case DataGridActionTypes.RESET_GRID_PAGINATION_URLPARAMS_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data, value: getComputedGridParams(action.data) } })
            break;
        case DataGridActionTypes.SET_GRID_PAGINATION_PAGE_SIZE_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data.key, value: getComputedGridParams(action.data.key)} })
            break;
        case DataGridActionTypes.SET_GRID_SORTING_URLPARAMS_SAGA:
            yield put({ type: DataGridActionTypes.COMPUTE_GRID_URLPARAMS, data: {key: action.data.key, value: getComputedGridParams(action.data.key) } })
            break;
        default:
            break;
    }
}

function* watchSetGridUrlParams() {
    yield takeLatest(
      [
        DataGridActionTypes.SET_GRID_FILTR_URLPARAMS_SAGA,
        DataGridActionTypes.RESET_GRID_FILTR_URLPARAMS_SAGA,
        DataGridActionTypes.SET_GRID_PAGINATION_URLPARAMS_SAGA,
        DataGridActionTypes.RESET_GRID_PAGINATION_URLPARAMS_SAGA,
        DataGridActionTypes.SET_GRID_PAGINATION_PAGE_SIZE_SAGA,
        DataGridActionTypes.SET_GRID_SORTING_URLPARAMS_SAGA,
      ],
      handleSetGridUrlParams
    );
  }

// EXPORT
function* dataGridSaga() {
    yield all([
        call(watchSetGridUrlParams)
    ])
}

export default dataGridSaga;